import React from 'react';

/** Phase 4: MULTI PL Tab 写入的子期间；SINGLE / 未设置时为 null（#20）。 */
export type WpPeriodScopeValue = {
    periodFrom: string;
    periodTo: string;
    yearOfAssessment?: string | null;
    sliceKey?: string;
    /** MULTI: earliest Period Tab only — shared WP GET is allowed; later tabs must not reuse it */
    isFirstSlice?: boolean;
} | null;

export const WpPeriodScopeContext = React.createContext<WpPeriodScopeValue>(null);

export function useWpPeriodScopeContext(): WpPeriodScopeValue {
    return React.useContext(WpPeriodScopeContext);
}

/**
 * PL TotalSingle → paper-registry WP multi Tabs:
 * when true, WpPerCheck Total final follows the active Period Tab
 * (not PPE span endpoints: last-tab c/f / first-tab b/f).
 */
export const WpPerCheckFollowActiveTabContext = React.createContext(false);

export function useWpPerCheckFollowActiveTab(): boolean {
    return React.useContext(WpPerCheckFollowActiveTabContext);
}
